import { calcShortcutInterval } from '@utils';
import { metricKeys } from '@pulse/metrics';
import { DATE_SHORTCUTS } from '@utils/constants';

export const DEFAULT_ML_FILTER = {
  name: 'All Traffic',
  rule: [[]],
};

export const COLORS = ['#0f93f5', '#9777ed', '#e25baa'];

export const DEFAULT_ML_METRICS = [
  metricKeys.Attempts,
  metricKeys.VideoStartFailures,
  metricKeys.ExitBeforeVideoStarts,
  metricKeys.VideoStartTime,
  metricKeys.Plays,
];

export const LIVE_EXCLUDE_METRICS = [
  // add metric to exclude from ML live
];

export const DEFAULT_ML_DIMENSION = 'OBJECT_NAME';

export const DEFAULT_ML_GRANULARITY = 'PT1H';

export const DEFAULT_ML_METRIC_SORT = {
  filter: 0,
  metric: metricKeys.ConcurrentPlays,
  order: 'desc',
};

const [from, to] = calcShortcutInterval(DATE_SHORTCUTS.last6Hours);

export const DEFAULT_ML_INTERVAL = {
  from,
  to,
};

export const ML_REFRESH_INTERVAL = 3000;
